import api from './api';

export async function getPackages() {
  const response = await api.get('/packages');
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result; // { packages, cpPerCoin }
}

export async function getStaffPackages() {
  const response = await api.get('/staff/packages');
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result; // { packages, cpPerCoin }
}

export async function createPackage(coinCount, bonusPct, tagline, outlineColor, sortOrder) {
  const response = await api.post('/staff/packages', { coinCount, bonusPct, tagline, outlineColor, sortOrder });
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result; // new id
}

export async function replacePackage(id, coinCount, bonusPct, tagline, outlineColor) {
  const response = await api.post(`/staff/packages/${id}/replace`, { coinCount, bonusPct, tagline, outlineColor });
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result; // new id
}

export async function setPackageEnabled(id, enabled) {
  const response = await api.put(`/staff/packages/${id}/enabled`, { enabled });
  if (response.data.error !== undefined) throw new Error(response.data.error);
}

export async function reorderPackages(orderedIds) {
  const response = await api.put('/staff/packages/reorder', { orderedIds });
  if (response.data.error !== undefined) throw new Error(response.data.error);
}

export async function deletePackage(id) {
  const response = await api.delete(`/staff/packages/${id}`);
  if (response.data.error !== undefined) throw new Error(response.data.error);
}
